const COOKIE_CONSENT_KEY = 'cookieConsent';
const COOKIE_CONSENT_VERSION = '1.0';

export const CookieCategories = {
  NECESSARY: 'necessary',
  FUNCTIONAL: 'functional',
  ANALYTICS: 'analytics',
  MARKETING: 'marketing'
};

export const defaultCookiePreferences = {
  version: COOKIE_CONSENT_VERSION,
  [CookieCategories.NECESSARY]: true, // Always enabled
  [CookieCategories.FUNCTIONAL]: false,
  [CookieCategories.ANALYTICS]: false,
  [CookieCategories.MARKETING]: false,
  timestamp: null
};

export const getCookieConsent = () => {
  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) return null;

    const consent = JSON.parse(stored);

    // Check if version matches
    if (consent.version !== COOKIE_CONSENT_VERSION) {
      return null;
    }

    return consent;
  } catch (error) {
    console.error('Error reading cookie consent:', error);
    return null;
  }
};

export const saveCookieConsent = (preferences) => {
  try {
    const consent = {
      ...preferences,
      version: COOKIE_CONSENT_VERSION,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consent));
    return consent;
  } catch (error) {
    console.error('Error saving cookie consent:', error);
    return null;
  }
};

export const clearCookieConsent = () => {
  try {
    localStorage.removeItem(COOKIE_CONSENT_KEY);
  } catch (error) {
    console.error('Error clearing cookie consent:', error);
  }
};

export const hasConsent = (category) => {
  const consent = getCookieConsent();
  if (!consent) return false;
  return consent[category] === true;
};

export const acceptAllCookies = () => {
  return saveCookieConsent({
    [CookieCategories.NECESSARY]: true,
    [CookieCategories.FUNCTIONAL]: true,
    [CookieCategories.ANALYTICS]: true,
    [CookieCategories.MARKETING]: true
  });
};

export const acceptNecessaryOnly = () => {
  return saveCookieConsent({
    [CookieCategories.NECESSARY]: true,
    [CookieCategories.FUNCTIONAL]: false,
    [CookieCategories.ANALYTICS]: false,
    [CookieCategories.MARKETING]: false
  });
};

export const cookieCategoryInfo = {
  [CookieCategories.NECESSARY]: {
    title: 'Necessary Cookies',
    description: 'These cookies are essential for the website to function properly. They enable core functionality such as security, authentication, and accessibility. These cannot be disabled.',
    required: true
  },
  [CookieCategories.FUNCTIONAL]: {
    title: 'Functional Cookies',
    description: 'These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.',
    required: false
  },
  [CookieCategories.ANALYTICS]: {
    title: 'Analytics Cookies',
    description: 'These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.',
    required: false
  },
  [CookieCategories.MARKETING]: {
    title: 'Marketing Cookies',
    description: 'These cookies are used to track visitors across websites to display relevant advertisements and marketing campaigns.',
    required: false
  }
};
